module.exports = __webpack_public_path__ + "547d94fd2e95fc6f8b6e3c62b643e6f4.svg";